"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBBannerNotification", {
  enumerable: true,
  get: function get() {
    return _SVBBannerNotification.default;
  }
});
var _SVBBannerNotification = _interopRequireDefault(require("./src/SVBBannerNotification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }